export default __webpack_public_path__ + "billings.475037d.png";